import React, { useEffect } from "react";

const WelcomeRedirectComponent = () => {
  useEffect(() => {
    const landing =
      process.env.REACT_APP_IBRIDGE_APP_URL || "https://learnsmart.ibridge360.com";
    window.location.replace(landing.replace(/\/$/, "") + "/");
  }, []); // The empty array ensures this runs only once when the component is mounted

  return null; // Since we are redirecting, no need to render anything
};

export default WelcomeRedirectComponent;
